import React, { useState } from 'react';
import { useKeenSlider } from 'keen-slider/react';
import 'keen-slider/keen-slider.min.css';

const leadingWayData = [
    {
        id: 1,
        title: "Quantum Decentralized Notes",
        description: "Mobikode at Makers Labs builds Quantum Decentralized Notes for secure, smart, and seamless collaboration in next-gen digital innovation ecosystems.",
        image: "/assets/lab/img8.png",
        link: "#"
    },
    {
        id: 2,
        title: "Collaborate and create in the metaverse ",
        description: "Mobikode at Makers Labs helps people collaborate creatively, build ideas together, and shape engaging experiences in the evolving metaverse space.",
        image: "/assets/lab/img9.png",
        link: "#"
    },
    {
        id: 3,
        title: "Meta Bank ",
        description: "Mobikode at Makers Labs Meta Bank builds simple, human-centered digital products that help startups grow with smart, scalable technology solutions",
        image: "/assets/lab/img8.png",
        link: "#"
    }
];

export default function LeadingWaySection() {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [loaded, setLoaded] = useState(false);

    const [sliderRef, instanceRef] = useKeenSlider(
        {
            initial: 0,
            loop: true,
            slideChanged(slider) {
                setCurrentSlide(slider.track.details.rel);
            },
            created() {
                setLoaded(true);
            },
            breakpoints: {
                "(min-width: 640px)": {
                    slides: { perView: 1.5, spacing: 20 },
                },
                "(min-width: 768px)": {
                    slides: { perView: 2, spacing: 24 },
                }
            },
            slides: { perView: 1.1, spacing: 16 },
        },
        [
            (slider) => {
                let timeout;
                let mouseOver = false;

                function clearNextTimeout() {
                    clearTimeout(timeout);
                }

                function nextTimeout() {
                    clearTimeout(timeout);
                    if (mouseOver) return;
                    timeout = setTimeout(() => {
                        slider.next();
                    }, 3000);
                }

                slider.on("created", () => {
                    slider.container.addEventListener("mouseover", () => {
                        mouseOver = true;
                        clearNextTimeout();
                    });
                    slider.container.addEventListener("mouseleave", () => {
                        mouseOver = false;
                        nextTimeout();
                    });
                    nextTimeout();
                });
                slider.on("dragStarted", clearNextTimeout);
                slider.on("animationEnded", nextTimeout);
                slider.on("updated", nextTimeout);
            },
        ]
    );

    return (
        <section className="w-full pb-[40px] md:pb-[100px] overflow-hidden font-sora bg-white select-none">
            <div className="max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px]">

                <div className="flex items-center justify-between mb-[24px] md:mb-[60px]">
                    <h2 className="text-[20px] md:text-[30px] font-[600] text-[#01386A] tracking-tight">
                        Leading The Way
                    </h2>

                    {loaded && instanceRef.current && (
                        <div className="flex items-center gap-4">
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    instanceRef.current?.prev();
                                }}
                                className="w-10 h-10 rounded-full border border-[#F97316] text-[#F97316] hover:bg-[#F97316] hover:text-white flex items-center justify-center transition-colors duration-300"
                                aria-label="Previous slide"
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M19 12H5M12 19l-7-7 7-7" />
                                </svg>
                            </button>

                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    instanceRef.current?.next();
                                }}
                                className="w-10 h-10 rounded-full border border-[#F97316] text-[#F97316] hover:bg-[#F97316] hover:text-white flex items-center justify-center transition-colors duration-300"
                                aria-label="Next slide"
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M5 12h14M12 5l7 7-7 7" />
                                </svg>
                            </button>
                        </div>
                    )}
                </div>

                <div className="relative">
                    <div ref={sliderRef} className="keen-slider !overflow-visible lg:!overflow-hidden">
                        {leadingWayData.map((slide) => (
                            <div key={slide.id} className="keen-slider__slide">
                                <div className="group w-full h-[260px] sm:h-[280px] md:h-[320px] relative overflow-hidden rounded-sm bg-black cursor-pointer">

                                    <img
                                        src={slide.image}
                                        alt={slide.title}
                                        className="w-full h-full object-cover opacity-60 transition-transform duration-700 ease-out md:group-hover:scale-105 select-none"
                                    />

                                    <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent"></div>

                                    <div className="absolute inset-0 p-5 sm:p-6 md:p-8 flex flex-col justify-end space-y-2 sm:space-y-4">
                                        <h3 className="text-white text-[16px] md:text-[20px] font-[600] leading-tight max-w-md">
                                            {slide.title}
                                        </h3>

                                        <p className="text-white/80 text-[14px] lg:text-[16px] font-graphik font-medium leading-relaxed max-w-xl">
                                            {slide.description}
                                        </p>

                                        <div className="pt-1 sm:pt-2">
                                            <a
                                                href={slide.link}
                                                className="inline-flex items-center text-[14px] lg:text-[16px] font-[500] text-white tracking-wide font-sora transition-all duration-300"
                                            >
                                                <span className="relative after:absolute after:bottom-0 after:left-0 after:h-[1.5px] after:w-full after:origin-bottom-right after:scale-x-0 after:bg-white after:transition-transform after:duration-300 group-hover:after:origin-bottom-left group-hover:after:scale-x-100 pb-0.5">
                                                    Read More
                                                </span>

                                                <svg
                                                    className="w-4 h-4 ml-2 text-[#F97316] transition-transform duration-300 ease-out transform group-hover:translate-x-1.5"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    strokeWidth="2.5"
                                                    viewBox="0 0 24 24"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M9 5l7 7-7 7" />
                                                </svg>
                                            </a>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        ))}
                    </div>
                </div>

            </div>
        </section>
    );
}